import { baseEnvironment } from './environment-base';
import { Environment } from './environment-interface';

export const environment: Environment = {
	...baseEnvironment,
	production: true,
};
